function createAutocompleteInitialState(defaultState) {
  return {
    expanded: false,
    focusedOption: null,
    inputValue: defaultState.inputValue,
    value: defaultState.value,
    kbNavigation: false
  };
}
function autocompleteReducer(state, action) {
  switch (action.type) {
    case 'ADD_OPTION':
      {
        const {
          option,
          latestEvent
        } = action;
        return Object.assign(Object.assign({}, state), {
          inputValue: '',
          value: [...state.value, option],
          latestEvent
        });
      }
    case 'REMOVE_OPTION':
      {
        const {
          option,
          latestEvent
        } = action;
        const newSelectedOptions = [...state.value];
        newSelectedOptions.splice(newSelectedOptions.findIndex(selectedOption => selectedOption.value === option.value), 1);
        return Object.assign(Object.assign({}, state), {
          inputValue: '',
          value: newSelectedOptions,
          latestEvent
        });
      }
    case 'SELECT_OPTION':
      {
        const {
          option,
          latestEvent
        } = action;
        return Object.assign(Object.assign({}, state), {
          inputValue: option.title,
          value: [option],
          expanded: false,
          focusedOption: null,
          latestEvent
        });
      }
    case 'FOCUS_OPTION':
      {
        const {
          option,
          kbNavigation,
          latestEvent
        } = action;
        return Object.assign(Object.assign({}, state), {
          focusedOption: option,
          kbNavigation,
          latestEvent
        });
      }
    case 'UPDATE_INPUT_VALUE':
      {
        const {
          inputValue,
          expanded = true
        } = action;
        return Object.assign(Object.assign({}, state), {
          inputValue,
          expanded: expanded,
          focusedOption: null
        });
      }
    case 'UPDATE_VALUE':
      {
        const {
          value
        } = action;
        return Object.assign(Object.assign({}, state), {
          value
        });
      }
    case 'RESET':
      {
        return Object.assign(Object.assign({}, state), {
          inputValue: '',
          value: [],
          latestEvent: action.latestEvent
        });
      }
    case 'EXPAND':
      {
        return Object.assign(Object.assign({}, state), {
          expanded: true,
          latestEvent: action.latestEvent
        });
      }
    case 'COLLAPSE':
      {
        const {
          inputValue
        } = action;
        return Object.assign(Object.assign({}, state), {
          inputValue: inputValue !== undefined ? inputValue : state.inputValue,
          expanded: false,
          focusedOption: null,
          latestEvent: action.latestEvent
        });
      }
    default:
      {
        const unknownAction = action;
        throw Error("Unknown action: ".concat(unknownAction.type));
      }
  }
}

export { autocompleteReducer, createAutocompleteInitialState };
